export default "__VITE_ASSET__9oyHb0w2__"